/**
 * The reset acknowledgement shown next to the checkbox. The backend logs both
 * the version and its own copy of this text — if the wording changes, bump the
 * version here and add the new text to SpaceResetService::ACKNOWLEDGEMENTS.
 */
export const RESET_ACKNOWLEDGEMENT = {
  version: '2026-10-v1',
  text: 'I understand that all transactions, recurring series, Money Paths and models in this space will be permanently deleted and cannot be recovered.',
} as const

export const RESET_SUCCESS_BANNER =
  'Space data reset. Enter your opening balances to get started.'

/** "1,240 transactions" / "1 transaction" */
export function plural(count: number, one: string, many = `${one}s`) {
  return `${count.toLocaleString('en-AU')} ${count === 1 ? one : many}`
}

/** 600 → "10:00" */
export function formatCountdown(seconds: number) {
  const s = Math.max(0, seconds)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}
